import * as andesType from './actionTypes';

export const initialState = {
  availableIncome: null,
  settledIncome: null,
  advanceableIncome: null,
  salesInProgress: null,
  loading: false,
  error: null,
  totalBalance: null,
  loadedAmounts: false,
  amountWithraw: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case andesType.SET_MERCHANT_BALANCE: {
      return {
        ...state,
        availableIncome: action.payload?.available_limit,
        loading: false,
      };
    }
    case andesType.SET_TOTAL_BALANCE: {
      return {
        ...state,
        totalBalance: action.payload,
      };
    }
    case andesType.SET_MERCHANT_AVAILABLE: {
      return {
        ...state,
        settledIncome: action.payload,
        loading: false,
      };
    }
    case andesType.SET_ALL_BALANCE: {
      return {
        ...state,
        allBalance: action.payload,
      };
    }
    case andesType.SET_ADVANCEABLE_INCOME: {
      return {
        ...state,
        advanceableIncome: action.payload,
        loading: false,
      };
    }
    case andesType.SET_GSC_BALANCE: {
      return {
        ...state,
        salesInProgress: action.payload.salesInProgress.totalAmount,
        loading: false,
      };
    }
    case andesType.FETCH_ANDES_BALANCE: {
      return {
        ...state,
        loading: true,
      };
    }
    case andesType.SET_ANDES_ERROR_GSC: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errGsc: action.payload.errGsc,
      };
    }
    case andesType.SET_ANDES_ERROR_MERCHANT_BALANCE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errMerchant: action.payload.errMerchant,
      };
    }
    case andesType.SET_ANDES_ERROR_MERCHANT_AVAILABLE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errMerchantAvailable: action.payload.errMerchantAvailable,
        totalBalance: null,
      };
    }
    case andesType.SET_ANDES_ERROR_ALL_BALANCE: {
      return {
        ...state,
        error: action.payload.error,
        errAllBalances: action.payload.errAllBalances,
      };
    }
    case andesType.SET_LOADED_AMOUNT: {
      return {
        ...state,
        loadedAmounts: action.payload,
      };
    }
    case andesType.SET_AMOUNT_WITHRAW: {
      return {
        ...state,
        amountWithraw: action.payload,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
